import React, { useState } from 'react';

import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import CustomTd from '../shared/table/CustomTd';
import FormControl from '../shared/inputs/FormControl';
import Row from 'react-bootstrap/Row';
import SubLeadSourceList from './SubLeadSourceList';
import PropTypes from 'prop-types';
import useForm from '../../utilities/useForm';
import ActionButton from '../shared/buttons/ActionButton';
import permissionsProvider from '../../utilities/permissionsProvider';

const LeadSourceEditor = ({
    item: initialItem,
    cancelEdit
}) => {
    const postUrl = '/api/lookups/LeadSource/edit';
    const getUrl = `/api/lookups/LeadSource/edit/${initialItem.id}`;

    const { item, ...form } = useForm(getUrl, postUrl, { item: initialItem });
    const [isEditing, setEditing] = useState(false);

    const cancelRename = () => {
        form.reset();
        setEditing(false);
    }

    const submitForm = () => {
        form.submitData(() => {
            setEditing(false);
        });
    }

    return (
        <div>
            <Table size="sm" className="my-4">
                <thead>
                    <tr>
                        <th>
                            <span>
                                Lead Source
                        </span>
                            <span style={{ position: "absolute", right: "20px" }}>
                                <ActionButton
                                    buttonText="Back To Lead Sources"
                                    imgSource="/images/back-arrow.svg"
                                    onClick={cancelEdit}
                                />
                            </span>
                        </th>
                        <th className="two-button-cell">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isEditing ? (
                        <tr>
                            <CustomTd>
                                <div style={{ height: '1.9em' }}>
                                    <FormControl
                                        name='name'
                                        defaultValue={item.name}
                                        onChange={form.formChange}
                                        validationError={item.name_error}

                                    />
                                </div>
                            </CustomTd>
                            <CustomTd className="two-button-cell">
                                <div className="d-inline-flex align-top">
                                    <div className="button-wrapper d-inline-block">
                                        <ActionButton
                                            buttonText="Save"
                                            imgSource="/images/check.svg"
                                            onClick={submitForm}

                                        />
                                    </div>
                                    <div className="button-wrapper d-inline-block">
                                        <ActionButton
                                            buttonText="Cancel"
                                            imgSource="/images/cancel.svg"
                                            onClick={cancelRename}
                                        />
                                    </div>
                                </div>
                            </CustomTd>
                        </tr>
                    ) : (
                            <tr>
                                <CustomTd>
                                    <div style={{ height: '1.9em', paddingTop: '0.2em' }}>
                                        {item.name}
                                    </div>
                                </CustomTd>
                                <CustomTd className="text-right">
                                    {permissionsProvider.canEdit(item.acl) &&
                                        <ActionButton
                                            buttonText="Rename"
                                            imgSource="/images/edit.svg"
                                            onClick={() => setEditing(true)}
                                        />
                                    }
                                </CustomTd>
                            </tr>
                        )}
                </tbody>
            </Table>
            <Row>
                <Col className="pb-4">
                    <SubLeadSourceList
                        id={item.id}
                        items={item.subLeadSources} />
                </Col>
            </Row>
        </div>
    );
}

LeadSourceEditor.propTypes = {
    editId: PropTypes.number,
    cancelEdit: PropTypes.func
};

export default LeadSourceEditor;